import { render, staticRenderFns } from "./CommonTicket.vue?vue&type=template&id=845c640a&scoped=true&"
import script from "./CommonTicket.vue?vue&type=script&lang=js&"
export * from "./CommonTicket.vue?vue&type=script&lang=js&"
import style0 from "./CommonTicket.vue?vue&type=style&index=0&id=845c640a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845c640a",
  null
  
)

export default component.exports